module.exports = __webpack_public_path__ + "media/hero_mv_sp.46540fa0.webm";